module.exports = __webpack_public_path__ + "img/noticeLog.1af2bb95.svg";